import React from 'react';
import { Clock, Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
interface IntroPageProps {
  onStart: () => void;
}
export function IntroPage({
  onStart
}: IntroPageProps) {
  return <div className="min-h-screen flex flex-col items-center px-4 py-8 max-w-md mx-auto animate-in fade-in duration-500" data-id="element-74">
      {/* Top Badge */}
      <div className="bg-primary/10 text-primary px-4 py-1.5 rounded-full text-xs font-bold mb-6 tracking-wide" data-id="element-75">
        🐾 Test Gratuito para Dueños de Perros Mayores
      </div>

      {/* Headlines */}
      <h1 className="text-3xl md:text-4xl font-bold text-text-main text-center mb-4 leading-tight" data-id="element-76">
        ¿Cuántos Años le Quedan a Tu Perro?
      </h1>

      <p className="text-lg text-primary font-medium text-center mb-8 leading-relaxed" data-id="element-77">
        Responde 15 preguntas y descubre si tu perro está envejeciendo más
        rápido de lo normal — y qué hacer hoy
      </p>

      {/* Trust Bar */}
      <div className="flex justify-center items-center gap-4 mb-8 text-xs text-text-main/70 w-full border-y border-text-main/5 py-4" data-id="element-78">
        <div className="flex items-center gap-1" data-id="element-79">
          <Clock className="w-3 h-3" data-id="element-80" />
          <span data-id="element-81">Solo 3 min</span>
        </div>
        <div className="w-px h-3 bg-text-main/20" data-id="element-82"></div>
        <div className="flex items-center gap-1" data-id="element-83">
          <span className="text-lg leading-none" data-id="element-84">🔬</span>
          <span data-id="element-85">Evidencia</span>
        </div>
        <div className="w-px h-3 bg-text-main/20" data-id="element-86"></div>
        <div className="flex items-center gap-1" data-id="element-87">
          <span className="text-lg leading-none" data-id="element-88">🐕</span>
          <span data-id="element-89">+2,400 dueños</span>
        </div>
      </div>

      {/* Hero Image — Before & After */}
      <div className="w-full rounded-2xl mb-8 overflow-hidden shadow-lg border border-text-main/10 relative" data-id="element-90">
        <img src="https://cdn.magicpatterns.com/uploads/cQxYCPK3u9em9WSDmHvRLi/ChatGPT_Image_25_feb_2026,_05_34_45_p.m..png" alt="Antes y después — cachorro vs perro mayor" className="w-full h-auto object-cover" data-id="element-91" />
        {/* Labels */}
        <div className="absolute bottom-3 left-3" data-id="element-92">
          <span className="text-white text-xs font-bold bg-primary/80 px-2.5 py-1 rounded shadow" data-id="element-93">
            ✨ ANTES
          </span>
        </div>
        <div className="absolute bottom-3 right-3" data-id="element-94">
          <span className="text-white text-xs font-bold bg-alert/80 px-2.5 py-1 rounded shadow" data-id="element-95">
            ⚠️ HOY
          </span>
        </div>
      </div>

      {/* Bullet Points */}
      <div className="w-full space-y-4 mb-8" data-id="element-96">
        {['Descubre si lo que come tu perro — balanceado o solo carne — está acortando su vida sin que lo notes', 'Identifica los 3 síntomas silenciosos de envejecimiento acelerado', 'Conoce el nivel de riesgo real de tu perro hoy', 'Obtén un plan personalizado según la edad y raza de tu perro'].map((point, i) => <div key={i} className="flex items-start gap-3" data-id="element-97">
            <div className="mt-1 bg-accent/10 p-1 rounded-full" data-id="element-98">
              <Check className="w-4 h-4 text-accent" strokeWidth={3} data-id="element-99" />
            </div>
            <span className="text-text-main/90 font-medium text-sm leading-snug" data-id="element-100">
              {point}
            </span>
          </div>)}
      </div>

      {/* Emotional Hook */}
      <p className="text-text-main/80 italic text-center text-sm mb-8 px-4" data-id="element-101">
        "Miles de dueños pensaron que su perro 'solo estaba viejo'... hasta que
        descubrieron la verdad."
      </p>

      {/* CTA */}
      <div className="w-full sticky bottom-4 bg-background/95 backdrop-blur-sm p-2 pb-4 border-t border-text-main/5 md:static md:bg-transparent md:p-0 md:border-0" data-id="element-102">
        <Button onClick={onStart} fullWidth size="xl" className="shadow-xl shadow-accent/20 animate-pulse-slow" data-id="element-103">
          🐾 INICIAR TEST GRATUITO →
        </Button>
        <p className="text-center text-[10px] text-text-main/40 mt-3 uppercase tracking-wider" data-id="element-104">
          Gratis · Sin registro previo · Resultado inmediato
        </p>
      </div>

      {/* Social Proof */}
      <div className="mt-8 text-center bg-white p-4 rounded-xl shadow-sm border border-text-main/5 w-full" data-id="element-105">
        <div className="flex justify-center gap-1 mb-2 text-accent" data-id="element-106">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-107" />)}
        </div>
        <p className="text-text-main/80 text-sm italic mb-2" data-id="element-108">
          "Nunca pensé que la comida de Toby le estaba robando años"
        </p>
        <p className="text-xs font-bold text-text-main/60" data-id="element-109">
          — Carmen R., Guadalajara
        </p>
      </div>
    </div>;
}